export default {"authContainer":"Authentication-authContainer-dfd4290","authLoadingIndicator":"Authentication-authLoadingIndicator-3749101"};